import './SPLandingPage.scss';
import { Box } from '@mui/material';
import GroupIcon from '../../../assets/images/GroupIcon.png';
import keyIcon from '../../../assets/images/keyIcon.png';
import NotificationsIcon from '../../../assets/images/NotificationsIcon.png';
import settingsIcon from '../../../assets/images/settingsIcon.png';
import SPOnboarding from '../../../components/SellerProfile/OnboardingBox/SPOnboardingBox';
import SPProfileBox from '../../../components/SellerProfile/ProfileBox/SPProfileBox';
import SPStatusBox from '../../../components/SellerProfile/StatusBox/SPStatusBox';
import SPUserCard from '../../../components/SellerProfile/ActivityCard/SPActivityCard';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function SPLandingPage() {

  
const {company_name ,isAdmin} = useSelector((state: any) => state.sellerProfile)

  window.scrollTo({ top: 0, behavior: 'smooth' });

  const { t,i18n } = useTranslation();

  const adminActivityCardData = [
    {
      id: 1,
      title: 'activityCard',
      name: t('sellerProfile.dashboard.users'),
      description: t('sellerProfile.dashboard.manageUsers'),
      image: GroupIcon,
      lable: 'Group Icon',
      link: '/seller-profile/users'
    },
    {
      id: 2,
      title: 'activityCard',
      name: t('sellerProfile.dashboard.apiContact'),
      description: t('sellerProfile.dashboard.manageAPIInfo'),
      image: keyIcon,
      lable: 'Key Icon',
      link: '/seller-profile/api-credentials'
    },
    {
      id: 3,
      title: 'activityCard',
      name: t('sellerProfile.dashboard.notifications'),
      description: t('sellerProfile.dashboard.manageDistributionList'),
      lable: 'Notifications Icon',
      image: NotificationsIcon,
      link: '/seller-profile/notifications'
    },
    {
      id: 4,
      title: 'activityCard',
      name: t('sellerProfile.dashboard.mySettings'),
      description: t('sellerProfile.dashboard.manageAccountSettings'),
      lable: 'Settings Icon',
      image: settingsIcon,
      link: '/seller-profile/user-settings'
    }
  ];

  const userActivityCardData = [adminActivityCardData[3]];
  //const onboardingCompleted = onboardingStatus?.completed === 3
  const userDataForUserType = isAdmin
    ? adminActivityCardData
    : userActivityCardData;

    const getProfileText = (language, company_name) => {
      switch (language) {
        case 'fr':
          return `${t('sellerProfile.dashboard.profile')} ${company_name}`;
        case 'en':
          return `${company_name} ${t('sellerProfile.dashboard.profile')}`;
        default:
          return `${company_name} ${t('sellerProfile.dashboard.profile')}`;
      }
    };
  return (
    <main className="spLandingPageContainer">
      <h3>
        {getProfileText(i18n.language, company_name)}
      </h3>
      {isAdmin && <SPOnboarding />}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
        <SPStatusBox />
        <Box className="profileContainer">
          <SPProfileBox />
          <SPUserCard
            className="userCardsContianer"
            activityCardData={userDataForUserType}
          />
          <Box className="quickLinks">
            {t('sellerProfile.dashboard.quickLinks')}{' '}
            <a
              href={process.env.REACT_APP_JIRA_URL}
              target="_blank"
              rel="noreferrer"
            >
              Jira{' '}
              <img
                src="/images/icons/openInNewTabIcon.png"
                alt="Open  in new tab"
              ></img>
            </a>
            <a
              href={process.env.REACT_APP_SANDBOX_URL}
              rel="noreferrer"
              target="_blank"
            >
              {t('sellerProfile.dashboard.ADA002')}{' '}
              <img
                src="/images/icons/openInNewTabIcon.png"
                alt="Open  in new tab"
              ></img>
            </a>
          </Box>
        </Box>
      </Box>
    </main>
  );
}

export default SPLandingPage;
